import React, { Component } from 'react';
import Icon from './Icon';
import AppInfo from './AppInfo'
import './App.css';


const appInfo = { "daily" : "Daily is a Bible reading app that uses the Robert Roberts reading plan. Daily makes aims to make the daily readings simple, with no visual clutter or unwanted tools.",
                  "planner": "Planner is a Youth Group planning app. Planner makes it easy to manage your CYC activities, with quick event creation and editing abilities. With a simple calendar view, it’s super easy for your users to see what is coming up. You can even notify your users of venue changes when they happen on the week of an event.",
                  "crouton": "Crouton is a simple meal planning app. Easily keep track of recipes you love by storing websites, images and notes associated with them. Use these recipes to plan your week ahead so you always know what’s for dinner."
                }


const appName = { "daily" : "Daily",
                  "planner": "Planner",
                  "crouton": "Crouton"
                }

const appLink = { 
                  "daily": "https://apps.apple.com/nz/app/daily-bible-reading/id1409024737",
                  "planner": "https://apps.apple.com/nz/app/plan/id1390131928",
                  "crouton": "https://apps.apple.com/nz/app/crouton/id1461650987"
                }

class Home extends Component {

  constructor(props){
    super()

    this.state = {
        detailCardVisible: false,
        selectedApp: "daily"
    }

    this.handleAppClick = this.handleAppClick.bind(this);
  }

  handleAppClick(appName){
    this.setState({
        detailCardVisible: true,
        selectedApp: appName
    });
  }

  render() {
    return (
        <div className="app">
        <div className="app-header">
          <div className="title">Devin Davies.</div>
          <div className="subtitle">One notch above a monotone.</div>
          <div className="app-group">
            <Icon imageName={"crouton"} onClick={this.handleAppClick}/>
            <Icon imageName={"planner"} onClick={this.handleAppClick}/>
            <Icon imageName={"daily"} onClick={this.handleAppClick}/>
          </div>
          {this.state.detailCardVisible &&
            <AppInfo appName={appName[this.state.selectedApp]} appDetail={appInfo[this.state.selectedApp]} appLink={appLink[this.state.selectedApp]}/>
          }
        </div>
      </div>
    );
  }
}

export default Home;




// WEBPACK FOOTER //
// ./src/Home.js